/* EZ homepage (2026-10 redesign). Small helpers for the ez-home-* sections. */
(function () {
  if (window.__ezHome) return;
  window.__ezHome = true;

  // Hero: the loop autoplays from the HTML and fades in over the still frame once its first
  // frame plays. If a browser refuses autoplay (iPhone Low Power Mode, data saver) it tries
  // again on the first touch, scroll or key. It plays for every visitor, including devices
  // set to reduce motion (Windows with animation effects off reports that).
  function hero() {
    var videos = document.querySelectorAll('[data-ez-hero-video]');
    for (var i = 0; i < videos.length; i++) {
      playHero(videos[i]);
    }
  }
  function playHero(v) {
    v.muted = true;
    v.defaultMuted = true;
    var show = function () { v.classList.add('is-playing'); };
    v.addEventListener('playing', show);
    if (!v.paused) show();
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        var events = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
        var retry = function () {
          events.forEach(function (t) { window.removeEventListener(t, retry); });
          var q = v.play();
          if (q && q.catch) q.catch(function () {});
        };
        events.forEach(function (t) { window.addEventListener(t, retry, { passive: true }); });
      });
    }
  }

  // First screen: the hero's CSS assumes the theme's usual header and badge strip heights.
  // Measure the real ones (the announcement bar can wrap, the strip can take two rows) so the
  // strip lands exactly at the bottom of the window.
  function fold() {
    var hero = document.querySelector('[data-ez-hero]');
    if (!hero) return;
    var proof = document.querySelector('.ez-proof');
    var set = function () {
      hero.style.setProperty('--ez-above', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px');
      if (proof) hero.style.setProperty('--ez-proof', Math.round(proof.getBoundingClientRect().height) + 'px');
    };
    set();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(set, 150); });
  }

  // Phone call bar: shows once the hero has scrolled away.
  function callBar() {
    var bar = document.querySelector('[data-ez-callbar]');
    var hero = document.querySelector('[data-ez-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }).observe(hero);
  }

  // Video: a thumbnail until the visitor clicks, so no Wistia or YouTube code loads on page view.
  function youtube() {
    var btns = document.querySelectorAll('[data-ez-embed], [data-ez-yt]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var box = this.parentNode;
        var f = document.createElement('iframe');
        f.src = this.getAttribute('data-ez-embed') || 'https://www.youtube-nocookie.com/embed/' + this.getAttribute('data-ez-yt') + '?autoplay=1&rel=0';
        f.title = this.getAttribute('data-ez-title') || 'YouTube video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        box.innerHTML = '';
        box.appendChild(f);
      });
    }
  }

  // FAQ: every answer is in the page; on a phone only the first starts open.
  function faq() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var items = document.querySelectorAll('[data-ez-faq] details');
    for (var i = 1; i < items.length; i++) items[i].removeAttribute('open');
  }

  // Chat buttons open the store's chat when it is on the page, else go to the contact page.
  function chat() {
    var btns = document.querySelectorAll('[data-ez-chat]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        if (window.LiveChatWidget && window.LiveChatWidget.call) {
          e.preventDefault();
          window.LiveChatWidget.call('maximize');
        }
      });
    }
  }

  hero();
  function ready() { fold(); callBar(); youtube(); faq(); chat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
